'use client'

import { FunctionComponent, PropsWithChildren, useEffect } from 'react'
import ButtonProvider from '@/app/_providers/ButtonProvider/ButtonProvider'
import DebugTray from '@/app/_components/DebugComponents/DebugTray'
import EventBackButton from '@/app/_components/EventBackButton/EventBackButton'
import ExpirationModal from '@/app/_components/ExpirationModal/ExpirationModal'
import StickyMobileOrderFooter from '@/app/_components/StickyMobileOrderFooter/StickyMobileOrderFooter'
import Timer from '@/app/_components/Timer/Timer'
import { updateBodyClass } from '@/utils/dom.utils'

const EventsDetailLayoutContent: FunctionComponent<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    updateBodyClass('events-using-step-container')

    return () => {
      updateBodyClass(null, 'events-using-step-container')
    }
  }, [])

  return (
    <div className="event-page">
      <Timer isEvent />
      <EventBackButton />
      {children}
      <DebugTray />
      <ExpirationModal />
      <StickyMobileOrderFooter
        displayConfig={{ isEvent: true }}
      />
    </div>
  )
}

const EventDetailsLayoutShell: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <ButtonProvider>
    <EventsDetailLayoutContent>
      {children}
    </EventsDetailLayoutContent>
  </ButtonProvider>
)

export default EventDetailsLayoutShell
